module.exports = __webpack_public_path__ + "static/media/photo-3-m.860cf5b4.jpeg";